// A1 (Notes List call, 9 Oct 2026): open Notes List notes on a cue, for the cue asterisk.
// `counts` is the bound noteslist_note_counts/{projectId} doc, written only by the note-counts receiver as a full
// snapshot: `open` lists cues with open > 0, so a missing cue has none. Counts from an earlier link to another
// production are ignored until Notes List sends a snapshot for the current one.
export default function notesListOpenCount(integrationEnabled, project, counts, cueId) {
    if (!integrationEnabled || !project || project.noteslist_link_status !== 'linked') return 0;
    if (!counts || !counts.open) return 0;
    if (counts.production_id && counts.production_id !== project.noteslist_production_id) return 0;
    return counts.open[cueId] || 0;
}


// WEBPACK FOOTER //
// ./src/lib/noteslist-note-counts.js